const hook = {
    missing_events: '你需要提供至少一个事件。',
    send_test_payload_failed: '无法发送测试内容：{{message}}',
    endpoint_responded_with_error: '端点返回了错误。',
};
export default Object.freeze(hook);
